"use strict";

(self.webpackChunkuklash = self.webpackChunkuklash || []).push([ [ 318 ], {
  318: function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
    __webpack_require__.r(__webpack_exports__), __webpack_exports__.default = void (customElements.get("product-form") || customElements.define("product-form", class extends HTMLElement {
      form=this.querySelector("form");
      buttons=this.querySelectorAll('.shopify-product-form [type="submit"]');
      sticky=this.querySelector("[data-sticky]");
      notifier=this.querySelector("stock-notifier");
      options;
      constructor() {
        super(), this.updatePrice();
      }
      onChange() {
        let updateURL = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        this.updateOptions(), this.updateMasterId(), this.updatePrice(), this.updateVariantTitle(), 
        updateURL && this.updateURL(), this.sticky && this.updateSticky(), this.currentVariant ? this.currentVariant.available ? (this.updateButton("available"), 
        this.toggleNotifier()) : (this.updateButton("soldOut"), this.toggleNotifier("true")) : (this.updateButton("unavailable"), 
        this.toggleNotifier());
      }
      updateOptions() {
        this.options = Array.from(this.querySelectorAll('select[name^="option"],input[name^="option"]:checked'), (el => el.value));
      }
      updateMasterId() {
        1 === this.getVariantData().length ? this.currentVariant = this.getVariantData()[0] : this.currentVariant = this.getVariantData().find((variant => !variant.options.map(((option, index) => this.options[index] == option)).includes(!1))), 
        this.querySelector('[name="id"]').value = this.currentVariant ? this.currentVariant.id : "";
      }
      updatePrice() {
        this.currentVariant || this.updateOptions() && this.updateMasterId();
        var subscriptionPrice, subscriptionCompareAtPrice, price = this.getProductData().price, compareAtPrice = this.getProductData().compare_at_price;
        this.querySelector('[name="purchase_option"]:checked'), this.currentVariant && (price = this.currentVariant.price, 
        compareAtPrice = this.currentVariant.compare_at_price);
        const basePrice = subscriptionPrice = price, selling_plan = this.querySelector('select[name="selling_plan"] option[data-value]');
        if (selling_plan && selling_plan.dataset.value > 0) switch (subscriptionCompareAtPrice = Math.max(price, compareAtPrice), 
        selling_plan.dataset.valueType) {
         case "percentage":
          subscriptionPrice = (100 - selling_plan.dataset.value) / 100 * price;
          break;

         case "fixed_amount":
          subscriptionPrice = price - selling_plan.dataset.value;
          break;

         case "price":
          subscriptionPrice = selling_plan.dataset.valueType;
        }
        this.querySelectorAll("[data-price]").forEach((el => el.innerHTML = Shopify.formatMoney(price, Shopify.money_format))), 
        this.querySelectorAll("[data-base-price]").forEach((el => el.innerHTML = Shopify.formatMoney(basePrice, Shopify.money_format))), 
        this.querySelectorAll("[data-subscription-price]").forEach((el => el.innerHTML = Shopify.formatMoney(subscriptionPrice, Shopify.money_format))), 
        compareAtPrice > price ? this.querySelectorAll("[data-compare-at-price]").forEach((el => el.innerHTML = Shopify.formatMoney(compareAtPrice, Shopify.money_format))) : this.querySelectorAll("[data-compare-at-price]").forEach((el => el.textContent = "")), 
        subscriptionCompareAtPrice > subscriptionPrice ? this.querySelectorAll("[data-subscription-compare-at-price]").forEach((el => el.innerHTML = Shopify.formatMoney(subscriptionCompareAtPrice, Shopify.money_format))) : this.querySelectorAll("[data-subscription-compare-at-price]").forEach((el => el.textContent = ""));
      }
      updateButton(status) {
        var buttonText = window.strings.unavailable, disabled = !0;
        switch (status) {
         case "available":
          buttonText = window.strings.addToCart, disabled = !1;
          break;

         case "soldOut":
          buttonText = window.strings.soldOut;
        }
        this.buttons.forEach((button => {
          button.disabled = disabled, button.textContent = buttonText, disabled ? (button.classList.add("bg-putty", "border-putty", "text-black", "hover:bg-putty"), 
          button.classList.remove("bg-black", "text-white")) : (button.classList.add("bg-black", "text-white"), 
          button.classList.remove("bg-putty", "border-putty", "text-black", "hover:bg-putty"));
        }));
      }
      updateVariantTitle() {
        this.currentVariant && this.querySelectorAll("[data-variant-title]").forEach((el => el.textContent = this.currentVariant.title));
      }
      updateURL() {
        if (this.getVariantData().length <= 1 || !this.currentVariant) return;
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("variant", this.currentVariant.id), window.history.replaceState({}, "", `${this.dataset.url}?${searchParams.toString()}`);
      }
      updateSticky() {
        if (!this.sticky) return;
        const purchaseOption = this.querySelector('input[name="purchase_option"]:checked');
        if (!purchaseOption) return;
        const purchaseType = purchaseOption.value, stickyPriceElement = this.sticky.querySelector("[data-sticky-price]"), stickySubscriptionElement = this.sticky.querySelector("[data-sticky-subscription]"), sourcePriceElement = this.querySelector(`[data-type-price="${purchaseType}"]`);
        if (stickyPriceElement && sourcePriceElement && (stickyPriceElement.innerHTML = sourcePriceElement.innerHTML), 
        "subscription" === purchaseType && stickySubscriptionElement) {
          const sellingPlanSelect = purchaseOption.closest("label").querySelector('select[name="selling_plan"]');
          if (sellingPlanSelect) {
            const selectedOption = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
            selectedOption && (stickySubscriptionElement.textContent = selectedOption.text);
          }
        } else stickySubscriptionElement && (stickySubscriptionElement.textContent = "");
        const stickyVariantTitle = this.sticky.querySelector("[data-variant-title]");
        stickyVariantTitle && this.currentVariant && (stickyVariantTitle.textContent = this.currentVariant.title);
      }
      getProductData() {
        return this.querySelector('[type="application/json"][data-product-json]') ? this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent) : this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"]').textContent), 
        this.productData;
      }
      getVariantData() {
        return this.querySelector('[type="application/json"][data-variant-json]') ? this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"][data-variant-json]').textContent) : this.variantData = this.variantData || this.getProductData().variants, 
        this.variantData;
      }
      onSubmitHandler(event) {
        event.preventDefault(), Shopify.addToCart(this.form);
      }
      toggleNotifier() {
        let show = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        this.notifier && (show ? (this.notifier.classList.add("max-h-screen"), this.notifier.classList.remove("max-h-0")) : (this.notifier.classList.remove("max-h-screen"), 
        this.notifier.classList.add("max-h-0")));
      }
      toggleSticky(atc) {
        window.scrollY >= atc.offsetTop - atc.clientHeight - 35 ? this.sticky.classList.remove("opacity-0", "pointer-events-none") : this.sticky.classList.add("opacity-0", "pointer-events-none");
      }
      connectedCallback() {
        if (this.onChange(!1), this.addEventListener("change", this.onChange), this.form.addEventListener("submit", this.onSubmitHandler.bind(this)), 
        this.querySelectorAll("[data-quantity]").forEach((el => {
          el.addEventListener("click", (event => {
            event.preventDefault(), event.stopPropagation();
            let quantity = parseInt(this.parentNode.querySelector('[name="quantity"]').value);
            quantity = el.hasAttribute("data-minus") ? Math.max(1, quantity - 1) : quantity += 1, 
            this.closest(".shopify-section").querySelectorAll('[name="quantity"]').forEach((el => el.value = quantity));
          })), el.classList.remove("hidden");
        })), this.sticky) {
          this.updateSticky();
          const atc = this.querySelector("[data-atc]");
          this.toggleSticky(atc), window.addEventListener("scroll", (event => {
            this.toggleSticky(atc);
          }), {
            passive: !0
          });
        }
        try {
          const selling_plan = this.querySelector('select[name="selling_plan"]');
          if (selling_plan) {
            const disabled = selling_plan.querySelector("option:disabled");
            disabled.parentNode.removeChild(disabled);
          }
        } catch (e) {}
        (this.message = this.querySelector("[data-message]")) && this.message.addEventListener("input", (() => this.querySelectorAll("[data-max-chars]").forEach((el => el.textContent = this.message.value.length))));
      }
    }));
  }
} ]);